module.exports = __webpack_public_path__ + "img/undraw_abstract_re_l9xy.af011318.svg";